import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "year", label: "Année", required: true },
  { key: "title", label: "Titre", required: true },
  { key: "description", label: "Description", type: "textarea" },
];

export default function AdminHistorique() {
  return (
    <AdminCrud
      title="Historique"
      description="Les grandes étapes de l'histoire de l'association."
      addLabel="Ajouter une étape"
      table="history"
      fields={fields}
      listTitleKey="title"
      listSubtitleKey="year"
    />
  );
}